import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTranslation } from 'react-i18next';

export type BusinessUnit = 'us' | 'br' | 'all';

interface BusinessUnitSelectorProps {
  value: BusinessUnit;
  onChange: (value: BusinessUnit) => void;
  includeAll?: boolean;
  className?: string;
  disabled?: boolean;
}

export function BusinessUnitSelector({
  value,
  onChange,
  includeAll = true,
  className,
  disabled = false,
}: BusinessUnitSelectorProps) {
  const { t } = useTranslation();

  return (
    <Select
      value={value}
      onValueChange={(v) => onChange(v as BusinessUnit)}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={t('finance.selectBusinessUnit', 'Select Business Unit')} />
      </SelectTrigger>
      <SelectContent>
        {includeAll && (
          <SelectItem value="all">
            {t('finance.allUnits', 'All Units')}
          </SelectItem>
        )}
        <SelectItem value="us">
          🇺🇸 {t('finance.businessUnit.us', 'US (USD)')}
        </SelectItem>
        <SelectItem value="br">
          🇧🇷 {t('finance.businessUnit.br', 'BR (BRL)')}
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
